import { render, staticRenderFns } from "./mrbview.vue?vue&type=template&id=77ea031c&scoped=true&"
import script from "./mrbview.vue?vue&type=script&lang=js&"
export * from "./mrbview.vue?vue&type=script&lang=js&"
import style0 from "./mrbview.vue?vue&type=style&index=0&id=77ea031c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77ea031c",
  null
  
)

export default component.exports